module.exports = __webpack_public_path__ + "img/cropwise-img-logo.35bdbd20.png";